const state = {

}

const getters = {

}

const mutations = {

}

import actions from './actions'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/orgstructure/index.js